import { verifyRequiredBetaFeatures } from 'utils/betaFeatures/verifyRequiredBetaFeatures';
import { filterQueryParametersAndReplace } from 'utils/url';
import betaFeatures from './betaFeatures';

export default [
  {
    path: 'coupons(.do)(.go)',
    onEnterHandlers: [
      verifyRequiredBetaFeatures([betaFeatures.COUPONS20_PAGE]),
      filterQueryParametersAndReplace('/coupons'),
    ],
  },
];
